import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../../../utils/datetime';

import { useGetBroadcastInfo } from '../../../../queries/broadcast';
import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice';
import { Spinner } from 'react-bootstrap'
import { Dialog } from 'primereact/dialog'

function StreamPreview({ streamInfo }) {
    const { t } = useTranslation();
    const { isLoading, data } = useGetBroadcastInfo(streamInfo.id);
    const openDialog = useSelector((state) => state.global.openDialog);
    const dispatch = useDispatch()

    function capitalizeFirstLetter(sentence) {
        return sentence?.replace(/\b\w/g, function (match) {
            return match.toUpperCase();
        });
    }

    return (
        <Dialog visible={openDialog.streamPreview}
            style={{ width: '30%' }}
            breakpoints={{ '960px': '95vw' }}
            header={capitalizeFirstLetter(streamInfo?.name)}
            modal className="p-fluid"
            onHide={() => dispatch(toggleDialog("streamPreview"))}
        >
            <div className="d-flex py-3 px-5 flex-wrap mb-3 justify-content-center ">
                {
                    isLoading ?
                        <Spinner variant="primary" as="span" animation="border" size="lg" role="status" className='m-3' aria-hidden="true" />
                        :
                        <>
                            <div className="col-12 d-flex my-2">
                                <div className='col-4 fw-bolder'>{t('broadcast.preview_type')}</div>
                                <div className="col-8 d-flex flex-wrap text-capitalize">
                                    {
                                        streamInfo?.type.replace(/_/g, ' ').toLowerCase()
                                    }
                                </div>
                            </div>
                            <div className="col-12 d-flex my-2">
                                <div className='col-4 fw-bolder'>{t('broadcast.preview_status')}</div>
                                <div className={` col-8 d-flex flex-wrap text-capitalize 
                                ${streamInfo?.status == "FINISHED" ? "text-danger" : streamInfo?.status == "PUBLISHED" ? "text-warning" : "text-success"}`} >
                                    {
                                        streamInfo?.status.toLowerCase()
                                    }
                                </div>
                            </div>
                            <div className="col-12 d-flex my-2">
                                <div className='col-4 fw-bolder'>{t('broadcast.preview_creation_date')}</div>
                                <div className={`col-8 d-flex flex-wrap text-capitalize`} >
                                    {
                                        formatDateTime(streamInfo?.created_at)
                                    }
                                </div>
                            </div>
                            <div className="col-12 d-flex my-2">
                                <div className='col-4 fw-bolder'>{t('broadcast.preview_transmitter')}</div>
                                <div className="col-8 d-flex flex-wrap">
                                    <span className="badge bg-label-primary p-2 rounded">
                                        {
                                            data?.senders?.map(device => {
                                                return device?.name
                                            })
                                        }
                                    </span>
                                </div>
                            </div>
                            <div className="col-12 d-flex my-2">
                                <span className='col-4 fw-bolder '>{t('broadcast.preview_receivers')}</span>
                                <div className="col-8 d-flex flex-wrap">
                                    <span className="badge bg-label-primary p-2 rounded">
                                        {
                                            data?.receivers?.map(device => {
                                                return device?.name
                                            })
                                        }
                                    </span>
                                </div>
                            </div>
                        </>
                }
            </div>
        </Dialog>
    )
}

export default StreamPreview